import { all } from 'redux-saga/effects';

import counter from './counter/sagas';
import sagas from './claims/sagas';
import openClaim from './openClaim/sagas';
import coverage from './coverage/sagas';
import management from './management/sagas';
import stores from './stores/sagas';
import roles from './roles/sagas';
import certificates from './certificates/sagas';
import reports from './reports/sagas';
import portal from './portal/sagas';

export default function* rootSaga() {
  yield all([
    counter,
    sagas,
    coverage,
    openClaim,
    management,
    stores,
    roles,
    certificates,
    reports,
    portal,
  ]);
}
